import { Pipe, PipeTransform } from "@angular/core";







@Pipe({
    name: 'date_to_local'
})
export class DateToLocalPipe implements PipeTransform
{

    transform(value: any, ...args: any[]) 
    {

        return new Date(value).toLocaleDateString();
        
    }

}